import request from './request'

export function storyDetail(query) {
    return request({
        url: '/huhuapi/stories/storyDetail',
        method: 'post',
        data: query
    });
}
export function publisherRe(query) {
    return request({
        url: '/huhuactivity/Producer/grant_insignia.html',
        method: 'post',
        data: query
    })
}



// WEBPACK FOOTER //
// ./src/api/stories.js